export const ROUTE_PERMISSIONS: Record<string, string[]> = {
  adlink: ['viewer', 'editor', 'admin'],
  dashboard: ['admin'],
  discounts: ['viewer', 'editor', 'admin'],
  emails: ['viewer', 'editor', 'admin'],
  events: ['viewer', 'editor', 'admin'],
  'general-settings': ['viewer', 'editor', 'admin'],
  'private-selling': ['viewer', 'editor', 'admin'],
  'redis-manager': ['admin'],
  'service-charges': ['viewer', 'editor', 'admin'],
  transactions: ['viewer', 'editor', 'admin'],
  upgrade: ['viewer', 'editor', 'admin'],
  upsell: ['viewer', 'editor', 'admin'],
  users: ['admin'],
};

export function hasRouteAccess(
  routeKey: string,
  userRoles: readonly string[]
): boolean {
  const required = ROUTE_PERMISSIONS[routeKey];
  if (!required || required.length === 0) {
    return true;
  }
  return required.some(role => userRoles.includes(role));
}
